import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = e => e.stopPropagation()),
    class: _normalizeClass(['dropdown-body', ...$props.classes])
  }, [_renderSlot(_ctx.$slots, "default")], 2);
}